import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import StatisticsContainerComponent from '../components/StatisticsContainerComponent'
import { getInterviews } from '../actions'

function StatisticsContainer() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getInterviews({ params: {} }))
  }, [dispatch])

  return <StatisticsContainerComponent />
}

export default StatisticsContainer
